import {KoAPI} from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;

export const adminConsoleAPI = {
  ChangeOwnerByID(id){
    return KoAPI.update(`/api/${version}/account/owner/${id}`);
  },
  uploadFile(data){
    return KoAPI.post(`/api/${version}/upload`, { data });
  },
  updateSettings(data, id) {
    return KoAPI.update(`/api/${version}/admin/settings/${id}`, { data });
  },
  getByIdSettings(id){
    return KoAPI.get(`/api/${version}/admin/settings/${id}`);
  },
  getUsers(){
    return KoAPI.get(`/api/${version}/org/user`);
  },


  getHolidays(query) {
    return KoAPI.get(`/api/${version}/admin/holidaycalendar`, { query: { ...query } });
  },
  createOrUpdateHoliday(data, id) {
    if(id) {
      return KoAPI.update(`/api/${version}/admin/holidaycalendar/${id}`, { data: { ...data } });
    } else {
      return KoAPI.post(`/api/${version}/admin/holidaycalendar`, { data: { ...data } });
    }
  },
  deleteHoliday(id){
    return KoAPI.delete(`/api/${version}/admin/holidaycalendar/${id}`);
  },


  getAvailability() {
    return KoAPI.get(`/api/${version}/admin/availability`);
  },
  updateAvailability(data, id) {
    if(id) {
      return KoAPI.update(`/api/${version}/admin/availability/${id}`, { data: { ...data } });
    }
  },
  updateLeaveTotalDays(data) {
    return KoAPI.update(`/api/${version}/admin/org/leave/total/days`, { data });
  },
  
  createOrUpdateLeaveType(data, id) {
    if(id) {
      return KoAPI.update(`/api/${version}/admin/org/leave/edit/${id}`, { data });
    }else{
      return KoAPI.update(`/api/${version}/admin/org/leave/total/days`, { data });
    }
   
  },
  
  getAllLeaves(query) {
    return KoAPI.get(`/api/${version}/admin/org/leaves`,{ query: { ...query } });
  },
  
  getLeaveById(id) {
    return KoAPI.get(`/api/${version}/admin/org/leave/${id}`);
  },
  
  removeLeave(id) {
    return KoAPI.delete(`/api/${version}/admin/org/leave/remove/${id}`);
  },
  createOrUpdatePlatform(data, id){
    if(id) {
      return KoAPI.update(`/api/${version}/org/meeting/platform/${id}`, { data: { ...data } });
    } else {
      return KoAPI.post(`/api/${version}/org/meeting/platform`, { data: { ...data } });
    }
  },
  getPlatform(){
    return KoAPI.get(`/api/${version}/org/meeting/platform/list`);
  },
  deletePlatform(id){
    return KoAPI.delete(`/api/${version}/org/meeting/platform/${id}`);
  },
  connectOauth(id){
    return KoAPI.get(`/api/${version}/org/meeting/${id}/url`);
  },

  createCategory(data){
    return KoAPI.post(`/api/${version}/admin/expense/category`,{data});
  },
  getCategoryList(){
    return KoAPI.get(`/api/${version}/admin/expense/category/all`);
  },
  getLocations(query, workspaceId) {
    return KoAPI.get(`/api/${version}/taskplanner/location/list`, {
      query: { ...query }
    });
  },
  createOrUpdateLocation(data, id, workspaceId) {
    if (id) {
      return KoAPI.update(`/api/${version}/taskplanner/location/${id}`, {
        data: { ...data }
      });
    } else {
      return KoAPI.post(`/api/${version}/taskplanner/location`, {
        data: { ...data }
      });
    }
  },
  deleteLocation(id, workspaceId) {
    return KoAPI.delete(`/api/${version}/taskplanner/location/${id}`);
  },
  getDivision(query, workspaceId) {
    return KoAPI.get(`/api/${version}/taskplanner/division/list`, {
      query: { ...query }
    });
  },
  createOrUpdateDivision(data, id, workspaceId) {
    if (id) {
      return KoAPI.update(`/api/${version}/taskplanner/division/${id}`, {
        data: { ...data }
      });
    } else {
      return KoAPI.post(`/api/${version}/taskplanner/division`, {
        data: { ...data }
      });
    }
  },
  deleteDivision(id, workspaceId) {
    return KoAPI.delete(`/api/${version}/taskplanner/division/${id}`);
  },
  getBranch(query, workspaceId) {
    return KoAPI.get(`/api/${version}/taskplanner/branch/list`, {
      query: { ...query }
    });
  },
  createOrUpdateBranch(data, id, workspaceId) {
    if (id) {
      return KoAPI.update(`/api/${version}/taskplanner/branch/${id}`, {
        data: { ...data }
      });
    } else {
      return KoAPI.post(`/api/${version}/taskplanner/branch`, {
        data: { ...data }
      });
    }
  },
  deleteBranch(id, workspaceId) {
    return KoAPI.delete(`/api/${version}/taskplanner/branch/${id}`);
  }
};